import { render, staticRenderFns } from "./HeartIcon.vue?vue&type=template&id=21b7d120&"
import script from "./HeartIcon.vue?vue&type=script&lang=js&"
export * from "./HeartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports